<template>
  <form v-on:submit.prevent="handleSubmit" class="form-inline my-2 my-lg-0">
    <input v-model="search_text" class="form-control mr-sm-2 input-custom" type="search" placeholder="Search" aria-label="Search">
    <button class="btn btn-link p-0" type="submit">
      <svgicon id="searchicon" name="search_icon" width="20" height="20" :fill="false"/>
    </button>
  </form>
</template>
<script>
 export default {
   name: 'searcher',
   data() {
     return {
       search_text: null
     }
   },
   methods: {
     handleSubmit() {
       // Search articles for content
       if (this.search_text) {
         this.$router.push("/search_results/" + this.search_text);
       }
       // Reset
       console.log("Search for " + this.search_text);
     }
   }
 }
</script>
<style>
 svg path, svg circle {
     stroke: white;
     fill: white;
 }
 svg:hover path{
     stroke: #00cdff;
     fill: #00cdff;
 }

 input.input-custom {
     border-radius: 0;
     border: 0;
     width: 250px;
 }

</style>
